import { render, staticRenderFns } from "./productGroupsView.vue?vue&type=template&id=7ebb2ce4"
import script from "./productGroupsView.vue?vue&type=script&lang=js"
export * from "./productGroupsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports